import { Form } from "@/components/organisms/Form";
import { request } from "@/common/api";
import { Buttons } from "@/components/atoms/Buttons";
import { useState } from "react";
import { showAlert } from "@/components/containers/Alert";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { InputTextarea } from "@/components/atoms/Inputs/InputTextarea";
import { GET_CHEER_MESSAGES } from "@/common/querykeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";

export const CommentWritePage = () => {
  const queryClient = useQueryClient();
  const [content, setContent] = useState("");

  const { mutateAsync: createComment, isPending } = useMutation({
    mutationFn: (data: { content: string }) =>
      request({
        method: "POST",
        url: "/cheer-message",
        data: data,
      }),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [GET_CHEER_MESSAGES] });
      window.history.back();
    },
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isPending) return;

    if (!content.trim()) {
      showAlert("메시지를 입력해 주세요.");
      return;
    }

    createComment({
      content: content,
    });
  };

  return (
    <MainTemplate
      nav={false}
      subPage={true}
      menuBtn={false}
      pageTitle="응원 메시지 보내기"
      buttonLeft={
        <Buttons
          type="button"
          size="headerTextIcon"
          layout="text"
          color="bright100"
          icon={<IconArrow />}
          label="응원"
          onClick={() => window.history.back()}
        />
      }
    >
      <Form
        onSubmit={handleSubmit}
        submitBtn={
          <Buttons
            type="submit"
            size="lg"
            layout="solid"
            color="primary100"
            label="메시지 등록"
            disabled={isPending}
          />
        }
        backBtn={
          <Buttons
            type="button"
            size="lg"
            layout="text"
            color="primary100"
            label="취소"
            onClick={() => window.history.back()}
          />
        }
      >
        <InputTextarea
          label="메시지 입력"
          placeholder="학생 회원에게 전달할 응원 메시지를 입력해 주세요."
          onChange={(e) => setContent(e.target.value)}
        />
      </Form>
    </MainTemplate>
  );
};
